@if (!onMobileView) {
  <div  >
    <ion-card class="hoverOnCard report-card-shell" [routerLink]="['/home/reports/', report.ReportID, report.ReportType.ReportType]" [queryParams]="{id: groupId}">
      <div class="report-card-img-container">
        @if (!report.ImageURI && isPublicLogoUrl($safeNavigationMigration(group?.LogoURL))) {
          <img class="group-logo report-card-img" [src]="$safeNavigationMigration(group?.LogoURL)" />
        } @else {
          @if ((report.ImageURI ? report.ImageURI : $safeNavigationMigration(group?.LogoURL)) | secureBlob | async; as imgSrc) {
            <img class="group-logo report-card-img" [src]="imgSrc" />
          } @else {
            <ion-spinner name="circular" class="report-card-img-spinner"></ion-spinner>
          }
        }
        <!-- <ion-icon *ngIf="report.Pinned" name="pin-outline" class="report-card-pin-badge"></ion-icon> -->
      </div>
      <!-- <ion-item lines="none" class="report-card-type-row">
      <ion-grid class="report-card-type-grid">
        <ion-row class="report-card-type-row-inner">
          <ion-col size="12" class="report-card-type-col">
            <ion-icon *ngIf="report.ReportType.ReportType === 'PowerBIReport'" name="bar-chart-outline" class="icon report-type-icon"></ion-icon>
            <ion-icon *ngIf="report.ReportType.ReportType === 'PaginatedReport'" name="map-outline" class="icon report-type-icon"></ion-icon>
            <ion-icon *ngIf="report.ReportType.ReportType === 'Dashboard'" name="analytics-outline" class="icon report-type-icon"></ion-icon>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item> -->
    <!-- <ion-col class="report-card-group">{{ group?.IsAllGroup ? group?.Name : group?.CollapsableTitle }}</ion-col> -->
    <div class="report-card-info">
      <div class="report-card-collection">
        <span>{{report.Title}}</span>
      </div>
      <div class="report-card-title-text">{{ ((portalVersion === 'V1' ? group?.Name : (group?.IsAllGroup ? group?.Name : group?.CollapsableTitle)) ?? '') | translate }}</div>
    </div>
    @if(report.Description) {
      <ion-text (click)="openDescriptionPopover($event)" class="card-detailsbutton report-card-desc-link">
        {{ 'Description' | translate }}
      </ion-text>
    }
    <div class="report-card-footer">
      <ion-button [color]="report.UsersFavorite ? 'primary' : 'medium'" (click)="setAsFavorite($event, report)" class="report-card-fav-btn">
        <ion-icon [name]="report.UsersFavorite ? 'star' : 'star-outline'" slot="start"></ion-icon>
        <span>{{ report.UsersFavorite ? ('Unfavorite' | translate) : ('Favorite' | translate) }}</span>
      </ion-button>
    </div>
  </ion-card>
</div>
} @else {
  <div style="color: var(--ion-color-secondary-contrast);text-align: center;" [routerLink]="['/home/reports/', report.ReportID, report.ReportType.ReportType]" [queryParams]="{id: groupId}">
    <ion-card class="hoverOnCard report-card-shell">
      <div class="report-card-img-container">
        @if (!report.ImageURI && isPublicLogoUrl($safeNavigationMigration(group?.LogoURL))) {
          <img class="group-logo report-card-img" [src]="$safeNavigationMigration(group?.LogoURL)" />
        } @else {
          @if ((report.ImageURI ? report.ImageURI : $safeNavigationMigration(group?.LogoURL)) | secureBlob | async; as imgSrc) {
            <img class="group-logo report-card-img" [src]="imgSrc" />
          } @else {
            <ion-spinner name="circular" class="report-card-img-spinner"></ion-spinner>
          }
        }
        <!-- <ion-icon *ngIf="report.Pinned" name="pin-outline" class="report-card-pin-badge"></ion-icon> -->
      </div>
      <ion-card-title class="report-card-title">
        <ion-row><ion-col class="card-title">{{report.Title}}</ion-col></ion-row>
      </ion-card-title>
      <div class="report-card-group-fixed">
        <ion-row *appRequiredRoles="[DirectiveRole.Premium]">
          <ion-col class="report-card-group">
            {{ portalVersion === 'V1' ? group?.Name : (group?.IsAllGroup ? group?.Name : group?.CollapsableTitle) }}
          </ion-col>
        </ion-row>
      </div>
      <div class="report-card-desc-fixed">
        @if(report.Description != null) {
          <ion-row>
            <ion-col>
              <!-- @if(report.Description.length > 25) { -->
              <div>
                <ion-text (click)="openDescriptionPopover($event)" class="card-detailsbutton report-card-desc-link-mobile">
                  {{ 'Description' | translate }}
                </ion-text>
              </div>
              <!-- } @else {
              <div class="report-card-desc">{{report.Description}}</div>
              } -->
            </ion-col>
          </ion-row>
        }
      </div>
      <div class="report-card-footer">
        <ion-button [color]="report.UsersFavorite ? 'primary' : 'medium'" (click)="setAsFavorite($event, report)" class="report-card-fav-btn">
          <ion-icon [name]="report.UsersFavorite ? 'star' : 'star-outline'" slot="start"></ion-icon>
          <span>{{ report.UsersFavorite ? ('Unfavorite' | translate) : ('Favorite' | translate) }}</span>
        </ion-button>
      </div>
    </ion-card>
  </div>
}


<ion-popover #descriptionPopover [isOpen]="descriptionPopoverOpen" (didDismiss)="descriptionPopoverOpen = false" [showBackdrop]="false" [alignment]="'center'" [cssClass]="'description-popover'">
  <ng-template>
    <ion-content class="description-popover-content">
      <div class="description-header">
        <ion-icon name="information-circle-outline" class="description-icon"></ion-icon>
        <ion-text class="description-title">{{ 'Report Description' | translate }}</ion-text>
      </div>
      <div class="description-body">
        <ion-text class="description-text">{{report.Description}}</ion-text>
      </div>
    </ion-content>
  </ng-template>
</ion-popover>
